(() => {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('q')) return;

  let shouldReplace = false;
  const requiredParameters = {
    type: 'product',
    'options[prefix]': 'last',
    'options[unavailable_products]': 'last',
  };

  Object.entries(requiredParameters).forEach(([name, value]) => {
    if (url.searchParams.get(name) === value) return;
    url.searchParams.set(name, value);
    shouldReplace = true;
  });

  if (shouldReplace) window.location.replace(url.toString());
})();
